import React from "react";

export default function PageHeader({ title, description, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-6">
      <div className="min-w-0">
        <h1 className="font-display text-2xl sm:text-[28px] font-semibold tracking-tight leading-tight pb-1 break-words sm:truncate">
          {title}
        </h1>
        {description && (
          <div className="text-sm text-muted-foreground mt-1.5">{description}</div>
        )}
      </div>
      {actions && <div className="flex gap-2 shrink-0 flex-wrap">{actions}</div>}
    </div>
  );
}
